import PocketBase from "pocketbase"

const pb = new PocketBase("https://leanny-seedchecker.fly.dev")
const base_url = window.location.origin
export const redirectUrl = `${base_url}/splat3seedchecker/#/auth`

export default pb
